export default {
  role_account: "Cuenta",
  role_account_dataexportxml: "XML",
  role_Users: "Usuarios",
  role_account_subusers: "Ver",
  role_account_subusers_edit: "Editar",
  role_Contacts: "Contactos",
  role_account_contacts: "Ver",
  role_account_contacts_edit: "Editar",
  role_account_loginhistory: "Historial inicios de sesión",
  role_Roles: "Roles",
  role_account_role: "Ver",
  role_account_role_edit: "Editar",
  role_Tags: "Etiquetas",
  role_account_tag: "Ver",
  role_account_tag_edit: "Editar",
  role_API: "API",
  role_account_apikeys: "Ver",
  role_account_apikeys_edit: "Editar",
  role_alrt: "Alertas",
  role_alrt_alertsadd: "Agregar",
  role_alrt_alertsedit: "Editar",
  role_alrt_alertsoffhour: "Fuera de horario",
  role_alrt_mediaalerts: "Administrar alertas de medios",
  role_account_ect2_read: "Configuración EVIR",

  role_apolloeld: "Apollo ELD",
  role_behavior: "Comportamiento",
  role_Behavior: "Comportamiento (Puntos)",
  role_behavior_behmng: "Ver",
  role_behavior_behmng_edit: "Editar",

  role_cariq: "Pago Car IQ",
  role_db: "Panel",
  role_defDrvr: "Conductor predeterminado",
  role_wgrs: "Advertencias de dispositivos",
  role_wgrs_wgdl: "Eliminar advertencias de dispositivos",
  role_wgrs_wgrd: "Resolver advertencias de dispositivos",

  role_dformview: "Mostrar formularios",
  role_drvapp: "Aplicación del conductor",
  role_drvapp_dappcht: "Chat",
  role_drvapp_dappfrm: "Formularios",
  role_DriverStatus: "Estado del conductor",
  role_drvapp_dappdst: "Ver",
  role_drvapp_dappdst_edit: "Editar",
  role_drvapp_dapptck: "Reloj de tiempo",
  role_drvapp_dapprta: "Rastreador de rutas",
  role_drvapp_dapprtc: "Tarjeta de tiempo",
  role_drvapp_dapprfr: "Formularios del conductor",
  role_drvapp_dapprcht: "Historial de chat",
  role_drvapp_dappfss: "Resumen de paradas de formularios V2",
  role_drvapp_dappcombr: "Combinado V2",
  role_drvapp_dappdrst: "Estado del conductor V2",
  role_drvapp_dappstsr: "Resumen de paradas V2",
  role_drvapp_bdrvcht: "Chat entre conductores",

  role_driverPer: "Rendimiento del conductor",
  role_eld: "ELDFleet",
  role_etalink: "Enlace ETA",

  role_evir: "EVIR",
  role_evir_adminusers: "Administrar usuarios",
  role_evir_showopen: "Ver informes de inspección",
  role_evir_addrepair: "Agregar registro de reparación",
  role_evir_assignmechanic: "Asignar usuario a reparación",
  role_evir_ect2customeradmin: "Asignar administrador del cliente",
  role_evir_evir2draftweb: "Probar configuraciones en borrador en EVIR 2.0 Web",
  role_evir_evir2draftmobile: "Probar configuraciones en borrador en EVIR 2.0 Móvil",
  role_evir_evir2inspector: "Realizar inspecciones",
  role_evir_evir2inspectorwithrentals: "Realizar inspecciones con alquileres",

  role_fcscoll: "Colecciones de rostros",
  role_feedback: "Comentarios",
  role_fldsync: "Sincronización de campos",
  role_fsm: "FSM",
  role_fsm_twowaycomm: "Mensajes",
  role_fsm_routemanager: "Rutas",
  role_fsm_fsmsettings: "Configuración",
  role_fsm_fsm_fg: "Formularios",
  role_fsm_drvtodrvcomm: "Comunicación conductor-conductor",

  role_pFuelLev: "Nivel de combustible",
  role_help: "Centro de ayuda",
  role_incdnt: "Incidentes",
  role_vm: "Mantenimiento heredado",
  "role_mntnnc-beta": "Mantenimiento",
  "role_mntnnc-beta_carb": "Verificación de emisiones",

  role_manage: "Administrar",
  role_Equipment: "Equipamientos",
  role_manage_ve: "Ver",
  role_manage_ve_edit: "Editar",
  role_manage_ckeyfob: "Etiquetas DriverID",
  role_manage_fuel: "Tarjetas de combustible",
  role_manage_ctemp: "Temperatura (Calamp)",
  role_Crews: "Tripulación",
  role_manage_cwm: "Ver",
  role_manage_cwm_edit: "Editar",
  role_UnitSettings: "Configuración de la unidad",
  role_manage_unitsettingsedit: "Ver",
  role_manage_unitsettingsedit_edit: "Editar",
  role_VehicleStatus: "Estado del vehículo",
  role_manage_vehstatuslabels: "Ver",
  role_manage_vehstatuslabels_edit: "Editar",
  role_Locations: "Ubicaciones",
  role_manage_unitlocations: "Ver",
  role_manage_unitlocations_edit: "Editar",
  role_manage_mediamanagecam: "Gestión de cámaras",
  role_Inputs: "Etiquetas de entradas",
  role_manage_inplbl: "Ver",
  role_manage_inplbl_edit: "Editar",
  role_Driver: "Conductores",
  role_manage_driver: "Ver",
  role_manage_driver_edit: "Editar",
  role_manage_delDriver: "Eliminar",
  role_Asset: "Activos",
  role_manage_ast: "Ver",
  role_manage_ast_edit: "Editar",
  role_Fuelcards: "Tarjeta de combustible",
  role_manage_fuel: "Ver",
  role_manage_fuel_edit: "Editar",
  role_AssetSubtypes: "Subtipos de activos",
  role_manage_aststp: "Ver",
  role_manage_aststp_edit: "Editar",
  role_Temperature: "Temperatura",
  role_manage_ctemp: "Ver",
  role_manage_ctemp_edit: "Editar",
  role_KeyFobs: "Llaveros",
  role_manage_ckeyfob: "Ver",
  role_manage_ckeyfob_edit: "Editar",
  role_DriverStatus: "Estados de conductor",
  role_manage_driverstatus: "Ver",
  role_manage_driverstatus_edit: "Editar",

  role_dformdesign: "Administrar formularios",
  role_dformdesign_sigcap: "Captura de firma",
  role_dformdesign_photoup: "Subir foto",

  role_realtimemaps: "Mapas",
  role_realtimemaps_gf: "Geocercas",
  role_realtimemaps_lm: "Puntos de referencia",
  role_realtimemaps_mapsettings: "Configuración de mapa",
  role_realtimemaps_maptrails: "Recorridos de vehículo",
  role_realtimemaps_sendsms: "Enviar mensajes",
  role_realtimemaps_maprouadd: "Rutas",
  role_realtimemaps_direct: "Direcciones de vehículo",
  role_realtimemaps_mapnearest: "Buscar el más cercano",
  role_realtimemaps_speedov: "Anulación de velocidad",
  role_realtimemaps_vctl: "Herramienta de proximidad",
  role_realtimemaps_animationmap: "Mapas animados",

  role_marketplace: "Mercado",
  role_media: "Medios",
  role_media_medialivevideo: "Obtener video en vivo",
  role_media_mediaimagesvideo: "Obtener imágenes y video",
  role_media_mediadownload: "Descargar medios",
  role_media_mediashare: "Compartir medios",
  role_media_mediaview: "Ver",
  role_media_mediaedit: "Editar",
  role_media_mediareview: "Realizar revisión",
  role_media_mediareviewchecklist: "Gestionar lista de verificación de revisión",
  role_media_mediapanicaler: "Recibir alertas de botón de pánico",

  role_mobile: "Móvil",
  role_mobile_appcloudmobile: "Cloud Mobile",

  role_monarch: "Monarch",
  role_monarch_mdriveri: "Cámaras Driver I",
  role_monarch_meld: "ELD Premium",
  role_monarch_mclassic: "Plataforma clásica",
  role_monarch_mditat: "DIAT TMS",
  role_monarch_intangles: "Monarch intangles",

  role_promiles: "Promiles",
  role_nr: "Informes",
  role_nr_sum: "Resumen",
  role_nr_der: "Detallado",
  role_nr_sur: "Simple",
  role_nr_spr: "Velocidad",
  role_nr_mir: "Kilometraje",
  role_nr_ssi: "Inicio Parada Ralentí",
  role_nr_idl: "Ralentí",
  role_nr_stp: "Parada",
  role_nr_ign: "Encendido",
  role_nr_tsr: "Parte de horas",
  role_nr_inp: "Entrada",
  role_nr_evt: "Evento",
  role_nr_sst: "En movimiento",
  role_nr_sr: "Informes programados",
  role_nr_gfr: "Geocerca",
  role_nr_stm: "Millas por estado",
  role_nr_lmi: "Punto de referencia",
  role_nr_lalo: "Latitud/Longitud",
  role_nr_lmb: "Basado en puntos de referencia",
  role_nr_dtsr: "Hoja de horas del conductor",
  role_nr_temp: "Temperatura",
  role_nr_ping: "Ping",
  role_nr_loc: "Ubicación",
  role_nr_ui: "Información de la unidad",
  role_nr_vmi: "Elementos de mantenimiento de vehículo (heredado)",
  role_nr_vsi: "Elementos de servicio de vehículo (heredado)",
  role_nr_ms: "Resumen de kilometraje",
  role_nr_fcr: "Compras de combustible",
  role_nr_mpg: "Millas por galón",
  role_nr_sfy: "Seguridad del conductor",
  role_nr_fch: "Historial de chat",
  role_nr_fsh: "Historial de paradas",
  role_nr_ftc: "Tarjeta de tiempo",
  role_nr_fdf: "Formularios de conductor FSM",
  role_nr_fc: "Combinado",
  role_nr_twm: "Mensajería bidireccional",
  role_nr_rse: "Eventos de parada de ruta",
  role_nr_mdf: "Formularios de conductor MDT",
  role_nr_mds: "Estado del conductor MDT",
  role_nr_did: "Indicadores de diagnóstico",
  role_nr_dpa: "Parámetros de diagnóstico",
  role_nr_teh: "Horas del motor",
  role_nr_jd: "Diagnóstico J-1708/1939",
  role_nr_js: "Resumen J-1708/1939",
  role_nr_gfb: "Basado en geocerca",
  role_nr_jdtc: "DTC J-1708/1939",
  role_nr_log: "Registro de alertas",
  role_nr_lmc: "Tripulación de punto de referencia",
  role_nr_nrr: "Sin reportar",
  role_nr_ssr: "Resumen de paradas",
  role_nr_or: "Odómetro",
  role_nr_fds: "Estado del conductor FSM",
  role_nr_avs: "Resumen avanzado",
  role_nr_mrs: "Resumen de reembolso por kilometraje",
  role_nr_ffss: "Resumen de paradas por formulario",
  role_nr_ls: "Resumen de puntos de referencia",
  role_nr_leh: "Horas de motor en puntos de referencia",
  role_nr_socutil: "Utilización Smart One C",
  role_nr_dvcsuminfo: "Resumen/Información del dispositivo",
  role_nr_utlz: "Utilización",
  role_nr_vehiclemaintenanceitems: "Elementos de mantenimiento de vehículo",
  role_nr_vehicleserviceitems: "Elementos de servicio de vehículo",
  role_nr_acr: "Actividad con informe de contador de horas",
  role_nr_smisum: "Informe de resumen de millas por estado",
  role_nr_smicross: "Informe de cruce de millas por estado",
  role_nr_tcr: "Tarjeta de tiempo V2",
  role_nr_chv2r: "Informe de historial de chat V2",
  role_nr_drfv2r: "Informe de formularios de conductor V2",
  role_nr_hoofus: "Informe de horas de uso",
  role_nr_behrep: "Informe de comportamiento",
  role_nr_drmisumm: "Informe de resumen de kilometraje del conductor",
  role_nr_drcoach: "Informe de entrenamiento de conductor",
  role_nr_spcoach: "Informe de entrenamiento de velocidad",
  role_nr_dlytpr: "Informe de viaje",
  role_nr_fllvlrp: "Informe de nivel de combustible",

  role_routes: "Rutas",
  role_vstat: "Estado",
  role_vstat_locate: "Localizar",
  role_vstat_uout: "Salidas",
  role_vstat_starter_ed: "Control de arranque",
  role_vstat_unitsettings: "Editar configuración de unidad",
  role_vstat_unitalertsheavy: "Alertas de vehículos pesados",
  role_vstat_unitalertsobd2: "Alertas de vehículos livianos",

  role_training: "Entrenamiento",
  role_trbusr: "Solución de problemas de usuario",

  role_vidfleetvideo: "Video",
  role_vidfleetvideo_livestreaming: "En vivo",
  role_vidfleetvideo_vidrw: "Revisión de video",
  role_vidfleetvideo_vfsetup: "Configuración de VidFleet",
  role_vidfleetvideo_dtlvdo: "Eliminar video",
  role_vidfleetvideo_vassdrv: "Asignar conductor",
  role_vidfleetvideo_vfdrid: "Configuración de VidFleet - ID de conductor",
  role_vidfleetvideo_privatecliprequest: "Solicitud de clip privado",
  role_vidfleetvideo_snapshoot: "Instántaneo",
  role_vidfleetvideo_videorequest: "Solicitud de video",
  role_vidfleetvideo_livevideo: "Video en vivo",
  role_oemdata: "Datos OEM",
  role_oemdata_remotecommands: "Comandos remotos",


  role_wbhook: "Webhook",
  role_workorders: "Órdenes de trabajo",
  role_WorkOrdersCatalogs: "Catálogos de órdenes de trabajo",
  role_workorders_womanage: "Ver",
  role_workorders_womanage_edit: "Editar",
  role_zpass: "Z Pass",
  role_zpass_adminzpass: "Administrador de Z Pass",
  role_zpass_viewzpass: "Ver Z Pass",

  role_zlogs: "Zonar ELD",
  role_zlogs_hosdispatch: "ZLogs - Horas de servicio - despacho",

  role_role: "Roles",
  role_permissions: "Permisos",
  role_alerts: "Alertas",
  role_reports: "Reportes",
  role_edit: "Editar Rol",
  role_create: "Crear un Nuevo Rol",
  role_label: "Etiqueta de Rol",
  role_minMessageUserType: "El rol debe contener un mínimo de caracteres:",
  role_maxMessageUserType: "El rol debe contener un máximo de caracteres:",
  role_globalAccess: "Acceso global",
  role_localAccess: "Acceso local",
  role_createMessage: "Rol Creado",
  role_editMessage: "Rol Actualizado",
  role_deleteMessage: "Rol Eliminado",
  role_messageDelete: "¿Estás seguro de que quieres eliminar los roles?",
  role_delete: "Eliminar Rol",
  role_custom: "Rol Personalizado",
  role_supervisor: "Supervisor",
  role_thisUsetsupervisor: "Este Usuario es Supervisor",
  "role_Data Exports": "Exportaciones de datos",
  role_General: "General",
  role_Alerts: "Alertas",
  role_Management: "Gestión",
  role_Reports: "Informes",
  role_Settings: "Ajustes",
  role_Maintenance: "Mantenimiento",
  role_Landmark: "Marca",
  "role_General Media": "Medios generales",
  "role_Media Review": "Revisión de medios",
  role_Basic: "Básico",
  role_Event: "Evento",
  role_Main: "Principal",
  role_Location: "Ubicación",
  role_Other: "Otro",
  "role_Legacy Maintenance": "Mantenimiento heredado",
  "role_Fuel Card": "Tarjeta de combustible",
  role_Diagnostic: "Diagnóstico",
  "role_Unit Specific Alerts": "Alertas específicas de la unidad"
};
